import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'components/common/tooltip/Tooltip'
import { FeatureContext } from 'components/FeatureContext'
import { ProsConsPills, ReviewKeyword, reviewKeywordShape } from 'components/supplier_shared/ProsConsPills'
import AiLabel from '../../../assets/images/ai-icon.svg'

interface RecentPerformanceProps {
  reviewsSummary: string
  reviewsSummaryLastUpdatedAt: string
  reviewsKeywords?: ReviewKeyword[]
}

export const RecentPerformance: React.FC<RecentPerformanceProps> = ({ reviewsSummary, reviewsSummaryLastUpdatedAt, reviewsKeywords = [] }) => {
  const featureFlags = useContext(FeatureContext)
  const tooltipAnchorEl = (
    <img src={AiLabel} alt='AI generated indicator' />
  )

  const tooltipContentEl = (
    <span>
      This summary was created by providing a robust sampling of reviews from the past 12 months into an artificial intelligence program.
    </span>
  )

  return (
    <div className='recent-performance ai-highlight cell small-12 medium-12'>
      <div className='recent-performance-title-row margin-bottom-05'>
        <div className='recent-performance-title color-pro-steel-grey-500'>
          <div>Recent Performance</div>
          <Tooltip anchor={tooltipAnchorEl} content={tooltipContentEl} />
        </div>
        <div className='recent-performance-last-updated color-pro-steel-grey-600 pro-text-xs'>
          Last Updated: {reviewsSummaryLastUpdatedAt}
        </div>
      </div>
      <div className='color-pro-steel-grey-700 pro-text-s' dangerouslySetInnerHTML={{ __html: reviewsSummary }} />
      {featureFlags.reviewsProsCons === true && reviewsKeywords.length > 0 && (
        <div className='recent-performance-pros-cons'>
          <div className='recent-performance-pros-cons-title'>Pros &amp; Cons</div>
          <ProsConsPills keywords={reviewsKeywords} />
        </div>
      )}
    </div>
  )
}

RecentPerformance.propTypes = {
  reviewsSummary: PropTypes.string.isRequired,
  reviewsSummaryLastUpdatedAt: PropTypes.string.isRequired,
  reviewsKeywords: PropTypes.arrayOf(reviewKeywordShape.isRequired)
}
